import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LazyMotion } from 'framer-motion';

import theme from './theme';
import { ContentProvider } from './content/ContentProvider';
import App from './App';

/*
 * Two animation libraries, one job each — this line is the contract:
 *
 *   GSAP owns the scroll: pins, scrubs, and scroll-triggered reveals.
 *   framer-motion owns component state: things mounting, leaving, springing.
 *
 * LazyMotion with the domAnimation bundle keeps framer-motion's cost to a few
 * KB in the initial load; components use <m.div> rather than <motion.div>,
 * which is what makes that saving real. strict throws if a full <motion.*>
 * component sneaks in.
 */
// Fetched after first paint; see animation/motionFeatures.js.
const loadMotionFeatures = () => import('./animation/motionFeatures').then((mod) => mod.default);

createRoot(document.getElementById('root')).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			{/* Normalises browser styling and installs the Montserrat @font-face rules. */}
			<CssBaseline />
			<LazyMotion features={loadMotionFeatures} strict>
				<ContentProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</ContentProvider>
			</LazyMotion>
		</ThemeProvider>
	</StrictMode>
);
